import { FC } from "react";

import ListagemUsuarioComponent from "../usuario/listagemUsuarioComponent";

const HomeRevenda: FC = () => {
  return <ListagemUsuarioComponent tipoUsuario="REVENDA" />;
};

export default HomeRevenda;
